import { KeyboardEvent } from 'react';

export const handleEscKeyPress = (close: () => void) => (
    event: KeyboardEvent<HTMLDivElement>,
): void => {
    if (event.key === 'Escape') {
        close();
    }
};
